var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 770,
    r: 230,
    fill: "#fb3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff553d",
    d: "M433 45c105 282-127 292-254.918 471.315C88.999 641.192 74 916 395 988c-135-71-164-277-18-406-37.695 125.105 31.57 205.291 118.652 175.852C581 729 636.452 790.294 635 860c-1 48-16 85-69 112 0 0 293-56 293-342 0-174-155-198.125-77-344-93 8-125.111 68.779-116 169 6 66-63 111.333-114 81.02-41.425-24.622-40-73.145-4-109.02 76.648-76.381 107-251-115-382"
  })));
};
export default SvgFire;